<template>
  <div>
    <!-- <el-button type="text" @click="dialogVisible = true">点击打开 Dialog</el-button> -->
    <el-dialog :title="who == 'createCoupons' ? '创建优惠卷' : '选择'" :visible.sync="dialogVisible"
      :close-on-click-modal="false" width="80%" top="5vh" :before-close="handleClose">
      <div class="template-body" v-if="headtemp == 'steps'">
        <!-- 如果需要步骤条 -->
        <div>
          <el-steps :active="active" simple>
            <el-step title="1、快速选卷" icon="el-icon-s-ticket" style="width: 50%;"></el-step>
            <el-step title="2、完善信息" icon="el-icon-s-order"></el-step>
          </el-steps>
        </div>

        <div class="template-body-main">
          <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:100%;float: left;">
            <!-- 卷模板 -->
            <div v-if="active == 0" style="padding:20px">
              <div v-for="(item, index) in CouponList" :key="index" :class="index == clicked
                ? 'template-body-main-item template-body-main-item-clicked'
                : 'template-body-main-item '
                ">
                <div @click="clickTemp(index, item)">
                  <!-- 卷模板样式组件 -->
                  <couponTemplate :coupon="item.key" :datas="item"></couponTemplate>
                </div>
              </div>
            </div>
            <!-- 卷信息修改 -->
            <div v-if="active == 1" style="padding:20px">
              <!-- 卷模板样式组件 -->
              <createCouponForm :coupon_data="CouponList[clicked]"></createCouponForm>
            </div>
            <!-- 完成并审核 -->
            <!-- <div v-if="active == 2" style="padding:20px">2</div> -->
          </el-scrollbar>
        </div>
      </div>
      <div v-if="headtemp == 'form'">
        <!-- TODO: 头部 是form搜索表单 还是步骤条 -->
        <div class="template-body-class">
          <div v-if="classList" class="template-body-class-l-f" style="">
            <span @click="classChange(item)" v-for="item in classList" :key="item" class="template-body-class-l-f-span"
              :class="ckeyWords.includes(item) == true
                ? 'template-body-class-l-f-clicked'
                : 'template-body-class-l-f-span'
                ">
              {{ item }}
            </span>
          </div>
          <div>
            <el-input placeholder="搜索模板" size="small" @change="searchTemplate">
              <template slot="append"><i class="el-icon-search"></i> </template>
            </el-input>
          </div>
        </div>
      </div>
      <div v-if="headtemp == 'steps'" class="dialog-footer">
        <el-button size="small" type="primary" plain class="footer-button"
          @click="active <= 0 ? (active = 1) : active--">上 一
          步</el-button>
        <el-button size="small" type="primary" plain class="footer-button"
          @click="active >= 1 ? (active = 0) : active++">下 一
          步</el-button>
      </div>
      <div v-if="headtemp == 'form'" slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" plain class="footer-button" @click="dialogVisible = false">取
          消</el-button>
        <el-button size="small" type="primary" plain class="footer-button" @click="chooseTemp">确 定</el-button>
      </div>
      <!--  headtemp=='steps' 步骤条 -->
    </el-dialog>
  </div>
</template>
<script>
import couponTemplate from "./couponTemplate.vue";
import { couponList } from "../js/couponList";
import createCouponForm from "./createCouponForm.vue";
export default {
  components: { couponTemplate, createCouponForm } /* createCoupons, */,
  name: "wty-template",
  data() {
    return {
      active: 0, //步骤条在第几步
      dialogVisible: false, //model组件是否显示
      alltemplate: [],
      CouponList: couponList, //卷列表
      ckeyWords: [],
      clicked: 0,
      temp_data: {}
    };
  },
  props: {
    who: {
      type: String,
      default: "createCoupons"
    },
    classList: {
      type: Array,
      default: a => {
        return ["专用货架牌", "双排条码纸", "测试"];
      }
    },
    // form"|"steps
    headtemp: {
      type: String,
      default: "steps"
    }
  },
  watch: {
    /*  active(na, oa) {
      console.log("新", na);
    } */
  },
  mounted() {
    console.log("who-----------", this.who);
  },
  methods: {
    /**
     * 选中的模板
     * @param {*} index 索引
     * @param {*} datas 模板数据
     */
    clickTemp(index, datas) {
      this.clicked = index;
      this.temp_data = datas;
      console.log("选择的卷模板", this.temp_data);
    },
    /**
     * 不在修改
     * @param key
     */
    stepsChange(key) {
      if (key === "+") {
        this.active++;
      } else if (key === "-") {
        this.active--;
      }
    },
    /**
     * 确定按钮
     */
    chooseTemp() {
      this.$emit("wtyTemplateReturn", this.CouponList[this.clicked]);
    },
    /**
     * 修改类别返回
     * @param keywords
     */
    classChange(keywords) {
      console.log("keywords", keywords);
      console.log("keywords", this.ckeyWords.includes(keywords));
      if (this.ckeyWords.includes(keywords)) {
        var a = [];
        for (let i = 0; i < this.ckeyWords.length; i++) {
          if (this.ckeyWords[i] !== keywords) {
            a.push(this.ckeyWords[i]);
          }
        }
        this.ckeyWords = a;
      } else {
        this.ckeyWords.unshift(keywords);
      }
      this.$emit("wtyTemplateReturn", this.ckeyWords);
    },
    searchTemplate() { },
    handleClose(done) {
      this.dialogVisible = false;

      /* this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {}); */
    },
    showDialog() {
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.template-body {
  width: 100%;
  height: 74vh;
  // background-color: rgba(178, 37, 37, 0.3);
  padding: 0 20px;

  &-class {
    height: 40px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-l-f {
      display: flex;
      align-items: center;
      width: calc(100% - 185px);
      height: 40px;
      scrollbar-width: none;
      padding: 0 10px 0 0;

      &-span {
        margin: 0 10px 0 0;
        color: #606266;
        cursor: pointer;
        user-select: none;
      }

      &-clicked {
        color: #409eff;
        font-weight: 700;
      }
    }

    &-father {
      min-width: 1500px;
    }

    &-item {
      display: inline-block;
      height: 40px;
    }
  }

  &-main {
    height: calc(100% - 40px);
    width: 100%;
    // background-color: #fff;
    border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
    padding: 10px 0;

    &-item {
      display: inline-block;
      width: auto;
      height: auto;
      background-color: transparent;
      margin: 0 10px 10px 0;
      padding: 10px;
      border-radius: 24px;
    }

    .template-body-main-item-clicked {
      //  0 0 20px #8b8b8b;
      transform: translate3d(0, 0, 20px);
      transform: scale(1.01);
      transition: all 0.5s;
      // border-bottom: 1px solid #000;;
      box-shadow: inset 0 0 30px #ffc800;
    }
  }

  &-main-empty {
    height: calc(100% - 40px);
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }
}

.dialog-footer {
  height: 60px;
  display: flex;
  justify-content: right;
  align-items: center;
  padding: 0 20px;

  .footer-button {
    width: 100px;
  }
}

/deep/.el-dialog__header {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/deep/.el-dialog__body {
  padding: 0 !important;
}

/deep/.el-dialog__footer {
  padding: 10px 20px;
}

/deep/ .el-dialog__headerbtn {
  top: 13px;
}

/deep/.el-input-group__append {
  padding: 0 10px !important;
}

/deep/.el-input {
  width: 185px !important;
}

/*滚动条样式*/
/deep/ .scrollbar {
  white-space: nowrap;

  .el-scrollbar {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }

  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
    height: 100%;
  }
}
</style>
